import {
  START_LOADING,
  END_LOADING,
  FETCH_PROJECTS,
  FETCH_PROJECT,
  ADD_PROJECT,
  UPDATE_PROJECT,
  DELETE_PROJECT,
  PROJECTS_ERROR,
} from "../actions/constants";

const initialState = {
  isLoading: false,
  projects: [],
  project: null,
  error: null,
};

const projects = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true, error: null };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_PROJECTS:
      return {
        ...state,
        projects: action.payload.data,
        error: null,
      };
    case FETCH_PROJECT:
      return {
        ...state,
        project: action.payload,
        error: null,
      };
    case ADD_PROJECT:
      return {
        ...state,
        projects: [...state.projects, action.payload],
        error: null,
      };
    case UPDATE_PROJECT:
      return {
        ...state,
        projects: state.projects.map((project) =>
          project._id === action.payload._id ? action.payload : project
        ),
        error: null,
      };
    case DELETE_PROJECT:
      return {
        ...state,
        projects: state.projects.filter(
          (project) => project._id !== action.payload
        ),
        error: null,
      };
    case PROJECTS_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default projects;
